import {bindActionCreators} from 'redux';
export default function mapDispatchToProps(action) {
    return dispatch => bindActionCreators(action, dispatch);
}


// WEBPACK FOOTER //
// ./src/utils/mapDispatchToProps.tsx